import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { ReactComponent as ConnectionSentIcon } from "Assets/svg/LinkedInAutomationWidget/connectionSent.svg";
import { ReactComponent as ConnectionAcceptedIcon } from "Assets/svg/LinkedInAutomationWidget/conectionAccepted.svg";
import { ReactComponent as MessageSentIcon } from "Assets/svg/LinkedInAutomationWidget/messageSent.svg";
import { ReactComponent as RepliesReceivedIcon } from "Assets/svg/LinkedInAutomationWidget/repliesReceived.svg";
import linkedInAutomationState from "./state";
import Utils from "Utils/utils";

const analyticsTableConfig = [
  {
    name: "Connections sent",
    id: "connectionRequestSentCount",
    icon: <ConnectionSentIcon />,
    color: "#2F7EDA"
  },
  {
    name: "Connections accepted",
    id: "connectionRequestAcceptedCount",
    icon: <ConnectionAcceptedIcon />,
    color: "#1EB1A7"
  },
  {
    name: "Messages sent",
    id: "messageSentCount",
    icon: <MessageSentIcon />,
    color: "#F49730"
  },
  {
    name: "Replies received",
    id: "replyReceivedCount",
    icon: <RepliesReceivedIcon />,
    color: "#8051D6"
  }
];

const LinkedInAutomationAnalytics = observer(props => {
  const [analyticsData, setAnalyticsData] = useState({});

  const constructAnalyticsData = () => {
    const data = linkedInAutomationState?.linkedInInsightData;
    let tempData = {
      connectionRequestSentCount: 0,
      connectionRequestAcceptedCount: 0,
      messageSentCount: 0,
      replyReceivedCount: 0
    };
    if (data && Object.keys(data)?.length) {
      // Check if data is a single summary object or a collection
      const isSingleObject = data.hasOwnProperty("linkedInMessagesSent") || 
                             data.hasOwnProperty("linkedinConnectionRequestsSent");

      if (isSingleObject) {
         const {
          linkedinConnectionRequestsSent = 0,
          linkedinConnectionRequestsAccepted = 0,
          linkedInMessagesSent = 0,
          linkedinRepliesReceived = 0
        } = data;
        tempData["connectionRequestSentCount"] = Math.ceil(linkedinConnectionRequestsSent) || 0;
        tempData["connectionRequestAcceptedCount"] = Math.ceil(linkedinConnectionRequestsAccepted) || 0;
        tempData["messageSentCount"] = Math.ceil(linkedInMessagesSent) || 0;
        tempData["replyReceivedCount"] = Math.ceil(linkedinRepliesReceived) || 0;
      } else {
        for (let item in data) {
          const {
            linkedinConnectionRequestsSent = 0,
            linkedinConnectionRequestsAccepted = 0,
            linkedInMessagesSent = 0,
            linkedinRepliesReceived = 0
          } = data?.[item];
          tempData["connectionRequestSentCount"] =
            tempData["connectionRequestSentCount"] +
              Math.ceil(linkedinConnectionRequestsSent) || 0;
          tempData["connectionRequestAcceptedCount"] =
            tempData["connectionRequestAcceptedCount"] +
              Math.ceil(linkedinConnectionRequestsAccepted) || 0;
          tempData["messageSentCount"] =
            tempData["messageSentCount"] + Math.ceil(linkedInMessagesSent) || 0;
          tempData["replyReceivedCount"] =
            tempData["replyReceivedCount"] + Math.ceil(linkedinRepliesReceived) || 0;
        }
      }
    }
    setAnalyticsData(tempData);
  };

  useEffect(() => {
    constructAnalyticsData();
  }, [linkedInAutomationState.linkedInInsightData]);

  return (
    <div className="linkedInAnalyticsWrapper">
      {!linkedInAutomationState?.linkedInInsightLoader ? (
        analyticsTableConfig?.map(item => {
          return (
            <div className="activityAnalyticsWrap" key={`${item?.name}`}>
              <div
                className="iconBadge"
                style={{ backgroundColor: `${item?.color}1A` }}
              >
                <div className="ico n" style={{ color: item?.color }}>
                  {item?.icon}
                </div>
              </div>
              <div className="textContainer">
                <div className="activityCount">
                  {Utils.formatNumberToStringInUSFormat(
                    analyticsData?.[item?.id]
                  )}
                </div>
                <div className="activityTitle">{item?.name}</div>
              </div>
            </div>
          );
        })
      ) : (
        <>
          {Array.from({ length: 4 }, (value, index) => (
            <div
              className="activityAnalyticsWrap activityAnalyticsLoader"
              key={`${value}-${index}`}
            >
              <section className="activityAnalyticsCont">
                <div className="activityCount linear-background" />
                <div className="activityTitle linear-background" />
              </section>
            </div>
          ))}
        </>
      )}
    </div>
  );
});

export { LinkedInAutomationAnalytics };
export default LinkedInAutomationAnalytics;
